import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { unwrappedSelectedFilterSetAtom } from '@/atoms/filters/userFilters';
import { TEMPORARY_FILTER_SET_ID } from '@/consts/filters/filterSets';

export const useSelectedFilterSetName = (): string => {
  const { t } = useTranslation('general');
  const selectedFilterSet = useAtomValue(unwrappedSelectedFilterSetAtom);

  return selectedFilterSet && selectedFilterSet.configId !== TEMPORARY_FILTER_SET_ID
    ? selectedFilterSet.definition.titleSettings.title
    : t('filters.other');
};
